import { InboxApi } from 'conversations/api'
import { Observable } from 'rxjs'
import { ConversationStatus } from 'shared/typings/conversations/status/ConversationStatus'

// These models have many more fields,
// but I've only inculded the ones we need here
interface InsightsMessage {
  author?: {
    name: string
    type: string
    email: null
  }
  basic: {
    createdAt: string
    body: string
  }
}

export interface InsightsConversation {
  orgId: number
  conversationId: number
  messages: InsightsMessage[]
  conversationTags: []
  meta: {
    company?: {
      name?: string
      domain?: string
      logo?: string
    }
    playbookName?: string
    durationMillis: number
    oldestMessageAt: number
    newestMessageAt: number
    inboxId: number
    orgId: number
    messageCount: number
    cqlRating: number
    status: ConversationStatus
    location?: {
      city: string
      region: string
      country: string
      postalCode: number
      location?: {
        lat: number
        lon: number
      }
    }
    initialUrl?: string
    emailCaptured: boolean
    testingConversation: boolean
    meetingBooked: boolean
  }
  customer: {
    id: number
    email?: string
    name?: string
    avatarUrl?: string
    employmentTitle?: string
  }
}

interface InsightsSearchResults {
  results: InsightsConversation[]
}

export const performInsightsConversationSearch = (
  searchTerm: string
): Observable<InsightsSearchResults> =>
  new Observable<InsightsSearchResults>((subscriber) => {
    InboxApi.get<InsightsSearchResults>(`/text/search?q=${encodeURIComponent(searchTerm)}`, {
      headers: {
        'x-version': '2',
      },
    })
      .then((response) => subscriber.next(response.data))
      .catch((error) => subscriber.error(error))
  })
